import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SubpageRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/private-office", { replace: true });
  }, [navigate]);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        width: "100%",
      }}
    />
  );
};

export default SubpageRedirect;
